const MappedLeitnerBoxWithDays: Record<string, string> = {
    BOX_1: 'Day 1',
    BOX_2: 'Day 2',
    BOX_3: 'Day 4',
    BOX_4: 'Day 7',
    BOX_5: 'Perfect',
};

const MappedLeitnerBoxWithDueText: Record<string, string> = {
    BOX_1: 'Due today',
    BOX_2: 'Due tomorrow',
    BOX_3: 'Due in 2 days',
    BOX_4: 'Due in 3 days',
    BOX_5: 'Review anytime',
};

export default MappedLeitnerBoxWithDays;
export { MappedLeitnerBoxWithDueText };
